import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';

const AgendaReviewDialog = ({ visible, agenda, loading, onHide, onConfirm }) => {
    const [comment, setComment] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (!visible) return;
        setComment('');
        setError('');
    }, [visible, agenda?._id]);

    const handleReturn = () => {
        const cleaned = comment.trim();
        if (cleaned.length < 3) {
            setError('Explica al vendedor qué debe ajustar.');
            return;
        }
        onConfirm?.({ action: 'returned', comment: cleaned });
    };

    const footer = (
        <div className="flex flex-column sm:flex-row justify-content-end gap-2">
            <Button type="button" label="Volver" className="p-button-text" onClick={onHide} disabled={loading} />
            <Button type="button" label="Devolver con comentario" icon="pi pi-replay" className="p-button-warning p-button-outlined" onClick={handleReturn} disabled={loading} />
            <Button type="button" label="Marcar revisada" icon="pi pi-check" onClick={() => onConfirm?.({ action: 'reviewed', comment: comment.trim() || undefined })} loading={loading} disabled={loading} />
        </div>
    );

    return (
        <Dialog className="ventas-dialog" header="Revisar agenda enviada" visible={visible} onHide={onHide} modal draggable={false} footer={footer} style={{ width: '38rem' }} breakpoints={{ '640px': '96vw' }}>
            <p className="text-color-secondary mt-0">Puedes marcar la agenda como revisada o devolverla al vendedor. Esta acción no modifica visitas ni reportes.</p>
            <label className="block font-medium mb-2">Comentario para el vendedor</label>
            <InputTextarea value={comment} rows={5} maxLength={1000} autoResize className="w-full" onChange={(event) => {
                setComment(event.target.value);
                setError('');
            }} placeholder="Indica cualquier observación o ajuste requerido." />
            {error ? <small className="p-error block mt-1">{error}</small> : null}
        </Dialog>
    );
};

export default AgendaReviewDialog;
